import React, { useState } from 'react'
import { ICONS } from '@Const/common'
import { formatPhoneNumber } from '@App/helpers/another-phone-formatter'
import { WorkMergeMemberVote, WorkMergeVote } from '@Entities/rightsholder/work-merge'
import './index.scss'

interface WorkMergeReviewVotesProps {
    votes: WorkMergeMemberVote[]
}

const voteText: Record<WorkMergeVote, string> = {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    PENDING: 'Pending',
}

const WorkMergeReviewVotes = ({ votes }: WorkMergeReviewVotesProps) => {
    const [expandedKeys, setExpandedKeys] = useState<string[]>([])

    const toggleVote = (key: string) =>
        setExpandedKeys((expanded) =>
            expanded.includes(key) ? expanded.filter((expandedKey) => expandedKey !== key) : [...expanded, key]
        )

    return (
        <div className="work-merge-review-votes">
            <p className="work-merge-review-votes-title">Associated Reviewers ({votes.length})</p>
            {votes.length === 0 && <p className="work-merge-review-votes-empty">No reviewers yet.</p>}
            {votes.map((vote) => {
                const key = String(vote.ipId)
                const isExpanded = expandedKeys.includes(key)

                return (
                    <div className="work-merge-review-votes-row" key={key}>
                        <div className="work-merge-review-votes-summary">
                            <button
                                className="work-merge-review-votes-toggle"
                                type="button"
                                aria-expanded={isExpanded}
                                onClick={() => toggleVote(key)}
                            >
                                <img
                                    src={isExpanded ? ICONS.chevron_drop_up : ICONS.chevron_drop_down}
                                    alt=""
                                    aria-hidden
                                />
                                <span className="work-merge-review-votes-member">{vote.memberName}</span>
                            </button>
                            {isExpanded && (
                                <div className="work-merge-review-votes-detail">
                                    {vote.contact ? (
                                        <>
                                            <p>{vote.contact.email}</p>
                                            {vote.contact.phoneNumber && (
                                                <p>{formatPhoneNumber(vote.contact.phoneNumber)}</p>
                                            )}
                                        </>
                                    ) : (
                                        <p>No contact details available.</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <span className="work-merge-review-votes-vote">{voteText[vote.vote ?? 'PENDING']}</span>
                    </div>
                )
            })}
        </div>
    )
}

export default WorkMergeReviewVotes
